import React, { useContext } from "react";
import styles from "./index.module.scss";
import Countdown from "components/Countdown/countdown";
import { Button, Dropdown, Menu } from "antd";
import { ExamContext } from "../../../../context";
import { isTrue } from "Utils/filter";
import ExamUploadModal from "../ExamUploadModal";
import useModalHandler from "../../../../../../../Utils/v2/useModalHandler";

interface ExamCountDownProps {
    disabled: boolean;
    now: string;
    endDateTime: string;
    onComplete: () => void;
    onSubmit: (count?: number, fileList?: string[]) => void;
    fileSize: number;
}

export default function ExamCountDown({
    disabled,
    now,
    onComplete,
    endDateTime,
    onSubmit,
    fileSize
}: ExamCountDownProps) {
    const captureModal = useModalHandler(undefined, { remove: true });
    const { examSettings, examId } = useContext(ExamContext);

    return (
        <div className={styles.root}>
            <div>交卷倒计时</div>
            {!endDateTime && (
                <div className={styles.tip}>倒计时正在生成中...</div>
            )}
            {endDateTime && (
                <div className={styles.countdown}>
                    {disabled ? (
                        "考试已结束"
                    ) : (
                        <Countdown
                            now={now}
                            onComplete={onComplete}
                            endDateTime={endDateTime}
                        />
                    )}
                </div>
            )}

            {!isTrue(examSettings?.catchPhoto) &&
                !isTrue(examSettings?.realtimeVideo) && (
                    <Button
                        disabled={disabled}
                        type="primary"
                        onClick={() => onSubmit()}>
                        交卷
                    </Button>
                )}

            {(isTrue(examSettings?.catchPhoto) ||
                isTrue(examSettings?.realtimeVideo)) && (
                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item onClick={() => onSubmit()}>
                                直接交卷
                            </Menu.Item>
                            <Menu.Item onClick={captureModal.open}>
                                上传作答内容 {fileSize !== 0 && `(${fileSize})`}
                            </Menu.Item>
                        </Menu>
                    }
                    placement="bottomLeft"
                    disabled={disabled}>
                    <Button
                        type="primary"
                        style={{ width: 100 }}
                        disabled={disabled}>
                        交卷
                    </Button>
                </Dropdown>
            )}

            {/*{isTrue(examSettings?.phoneUploadFile) && (*/}
            {/*    <div className={styles.remarks}>*/}
            {/*        系统监测到您当前正在使用手机上传本次考试的作答内容，作答内容成功上传后仅能手机侧交卷。*/}
            {/*    </div>*/}
            {/*)}*/}

            {captureModal.render(
                <ExamUploadModal examId={examId} onSubmit={onSubmit} />
            )}
        </div>
    );
}
